var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedLockCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.4118C3 10.632 3.64472 10 4.44 10H19.56C20.3553 10 21 10.632 21 11.4118V19.1765C21 20.7359 19.7106 22 18.12 22H5.88C4.28942 22 3 20.7359 3 19.1765V11.4118Z",
    stroke: "#FF003E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14L9.5 19",
    stroke: "#FF003E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14L14.5 19",
    stroke: "#FF003E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00286 10V9.78115C6.00286 7.609 5.87032 5.18783 7.40896 3.63325C8.28642 2.74671 9.70627 2 12 2C14.2937 2 15.7136 2.74671 16.591 3.63325C18.1296 5.18783 17.9971 7.609 17.9971 9.78115V10",
    stroke: "#FF003E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLockCross);
export default __webpack_public_path__ + "static/media/RedLockCross.2f61371beff7cc94660ee8200873a2e8.svg";
export { ForwardRef as ReactComponent };